import {DownloadFileWithGuidById} from "services/api_v2/Processes/Processes.service";
import {downloadDocumentFromUrl} from "../util/downloadDocumentFromUrl";
import useAlertMessage from "hooks/useAlertMessage";
import useLoading from "hooks/useLoading";

const useDownloadFromGuid = () => {
  const [showAlert] = useAlertMessage();
  const [setLoading] = useLoading();

  const handleDownloadFromGuid = async (
    guid: string | null | undefined,
    id: number,
    fileName?: string | null,
  ) => {
    if (!guid) {
      showAlert("guid inexistente ou inválido, tente novamente");
      return;
    }
    try {
      setLoading(true);

      const result = await DownloadFileWithGuidById(id);
      downloadDocumentFromUrl(result.data?.url, fileName ?? undefined);
    } catch (e: any) {
      console.error(e);
      showAlert(e?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return {handleDownloadFromGuid};
};

export default useDownloadFromGuid;
